import React from 'react';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';
import StatusIcon from '../StatusIcon.react';
import {ParentBox} from '../../box-utils/ParentBox.react.js';
import {safeJSONparse} from "../../../../common/util/safeJSONparse";

export default class Merk extends ParentBox {

    static propTypes = {
        isPreview: PropTypes.bool,
        viewWithData: PropTypes.object.isRequired,
    };

    getIcon() {
        return "merk";
    }

	getServiceName() {
		return "Merk";
	}

	getCompanyStatus(basic) {
		let errors = [];
		let statusIcon;
		let status;

		if (basic.vzp_debt) {
			errors.push(<FormattedMessage defaultMessage="VZP debt" id="merk.status.VZPDebts" />);
		}

		if (basic.is_unreliable_vatpayer) {
			errors.push(<FormattedMessage defaultMessage="Unreliable VAT payer" id="merk.status.is_unreliable_vatpayer" />);
		}

		switch ('status' in basic ? basic.status.id : 0) {
			case 0:
				// Issue #1387 - the company can be apparently just Unreliable VAT payer without andy reason...
				// errors.push(<FormattedMessage defaultMessage="Unknown" id="merk.status.unknown" />);
				break;
			case 1:
				//not an errors
				break;
			case 2:
				errors.push(<FormattedMessage defaultMessage="Under winding-up procedure" id="merk.status.is_closed" />);
				break;
			case 3:
				errors.push(<FormattedMessage defaultMessage="Subject of Insolvency Proceedings" id="merk.status.is_insolvent" />);
				break;
			case 4:
				errors.push(<FormattedMessage defaultMessage="Subject of Insolvency Proceedings" id="merk.status.is_insolvent" />);
				errors.push(<FormattedMessage defaultMessage="Under winding-up procedure" id="merk.status.is_closed" />);
				break;
			case 5:
				errors.push(<FormattedMessage defaultMessage="Under winding-up procedure" id="merk.status.is_closed" />);
				break;
			case 6:
				errors.push(<FormattedMessage defaultMessage="Terminated entity" id="merk.status.subject_terminated" />);
				break;
			case 7:
				errors.push(<FormattedMessage defaultMessage="Suspended business activity" id="merk.status.subject_suspended" />);
				break;
			case 8:
				errors.push(<FormattedMessage defaultMessage="Not yet operational" id="merk.status.subject_not_yet_operational" />);
				break;
			default:
				errors.push(basic.status.text);
		}

		if (errors.length > 0) {
			statusIcon = (<span className="merk-icon"><StatusIcon type={StatusIcon.ERROR} /></span>);
			status = errors.map((item, idx) => {
				if (idx === errors.length - 1) {
					return (<span key={idx * 2}>{item}</span>);
				}
				return [<span key={idx * 2}>{item}</span>, <br key={idx * 2 + 1} />];
			});
		}
		else {
			statusIcon = (<span className="merk-icon"><StatusIcon type={StatusIcon.OK} /></span>);
			status = <FormattedMessage defaultMessage="Subject is ok" id="merk.status.subject_is_ok" key="0" />;
		}

		return (
			<div className={"merk-status-table" + (status.length > 1 ? " manyErrors" : '')}>
				<div className="flex" key="1"></div>
				<div className="mark-icon-flex" key="2"><span className="dativeryValue">{statusIcon}</span></div>
				<div className="dativeryValue" key="3" ><span className="dativeryValue">{status}</span></div>
			</div>
		);
	}

	static isEmpty(viewWithData) {
		let {addon} = viewWithData;

		if (addon) {
			addon = safeJSONparse(addon);

			if (addon.merk && Array.isArray(addon.merk) && addon.merk.length > 0) {
				return false;
			}
		}

		return true;
	}
}
